import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";

const MUTATION = graphql(`
  mutation registerProfileActivity(
    $activity: String!
    $company: ID
    $payload: String
  ) {
    status: registerProfileActivity(
      activity: $activity
      company: $company
      payload: $payload
    ) {
      message
      triggers {
        type
        payload
      }
    }
  }
`);

type Data = ResultOf<typeof MUTATION>;
/** Variables of `registerProfileActivity`; `company` is nullable in the schema. */
export type Variables = VariablesOf<typeof MUTATION>;

export const useRegisterProfileActivityMutation = (
  options?: useMutation.Options<Data, Variables>,
): useMutation.ResultTuple<Data, Variables> =>
  useMutation<Data, Variables>(MUTATION, options);
